import React from 'react';
import { workProcessContent } from '../data/mock';

const WorkProcessSection = () => {
  return (
    <section id="como-trabajo" className="section-padding bg-[#f0f0f0]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="hero-subtitle text-[#666] mb-4">
            {workProcessContent.subtitle}
          </p>
          <h2 className="section-title text-[#333] mb-6">
            {workProcessContent.title}
          </h2>
          <div className="w-16 h-[1px] bg-[#333] mx-auto" />
        </div>

        {/* Content with image */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-start">
          {/* Process Steps */}
          <div className="order-2 lg:order-1">
            <div className="relative">
              {workProcessContent.steps.map((step, index) => (
                <div 
                  key={index}
                  className="flex gap-6 lg:gap-8 pb-10 last:pb-0"
                >
                  {/* Timeline */}
                  <div className="flex flex-col items-center">
                    {/* Number Circle */}
                    <div className="w-14 h-14 flex items-center justify-center border border-[#333] bg-[#fffef2] z-10 flex-shrink-0">
                      <span className="font-display text-lg font-light text-[#333]">
                        {step.number}
                      </span>
                    </div>
                    {/* Vertical Line */}
                    {index < workProcessContent.steps.length - 1 && (
                      <div className="w-[1px] flex-1 bg-[#bcbbb4] mt-4 min-h-[60px]" />
                    )}
                  </div>

                  {/* Content */}
                  <div className="flex-1 pt-3">
                    <h3 className="font-body text-base font-medium text-[#333] uppercase tracking-wide mb-4">
                      {step.title}
                    </h3>
                    <p className="body-regular text-[#666] leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Image */}
          <div className="order-1 lg:order-2 relative lg:sticky lg:top-32">
            <div className="aspect-[4/5] overflow-hidden">
              <img
                src={workProcessContent.image}
                alt="Proceso de trabajo - Luciana Belén"
                className="w-full h-full object-cover img-hover"
              />
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-4 -right-4 w-32 h-32 border border-[#bcbbb4] -z-10" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default WorkProcessSection;
